export enum Path {
  Home = '/',
  Login = 'login',
  AggregatedProjects = '/aggregated-projects',
}
